module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('p', [_vm._v("判断题小题说明")]), _vm._v(" "), (_vm.question.is_objective == 0 && _vm.moduleId == 124) ? _c('b', {
    attrs: {
      "title": "该题为主观题，需要您手动批改"
    }
  }, [_vm._v("批")]) : _vm._e(), _vm._v(" "), (_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ".")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "inline",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), (_vm.question.userAnswer) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setAnswers(_vm.question.userAnswer.answers[0].content))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), _c('tabTopic', {
    attrs: {
      "infoAnswer": _vm.question.ref_info.answers,
      "skillPoints": _vm.question.skill_points,
      "knowledgePoints": _vm.question.knowledge_points,
      "explains": _vm.question.explains,
      "qtype": 8,
      "tags": _vm.question.tags
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "option-box clearfix"
  }, [_c('div', {
    staticClass: "option-item"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _c('span', {
    staticClass: "m-l10"
  }, [_vm._v("正确")])]), _vm._v(" "), _c('div', {
    staticClass: "option-item"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  })]), _c('span', {
    staticClass: "m-l10"
  }, [_vm._v("错误")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab62bc5e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/judge.vue
// module id = 1237
// module chunks = 1